import { EndOfJourneyQuestion } from '../../lib/types/models/end-of-journey-template/end-of-journey-question'
import { EndOfJourneyQuestionInput } from '../../lib/types/models/end-of-journey-template/end-of-journey-question-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type UpdateEndOfJourneyQuestionInput = {
  templateId: number
  questionId: number
} & Partial<EndOfJourneyQuestionInput>

export function updateEndOfJourneyQuestion({
  templateId,
  questionId,
  ...data
}: UpdateEndOfJourneyQuestionInput): Promise<EndOfJourneyQuestion> {
  return restApiClient
    .url(
      constructApiUrl(API['end-of-journey-templates'].updateQuestion.url, {
        id: templateId,
        questionId
      })
    )
    .patch<EndOfJourneyQuestion, Partial<EndOfJourneyQuestionInput>>(data)
}
